import { HeroConsolidatedProps } from 'libs/contentful/props';
import HeroBaseVariant from './HeroBaseVariant';
import HeroBlogVariant from './HeroBlogVariant';
import HeroBaseWithBlogVariant from './HeroBaseWithBlogVariant';
import HeroFullBleedVariant from './HeroFullBleedVariant';
import { HeroVariants } from './constants';
import HeroPillarVariant from './HeroPillarVariant';

const HeroConsolidated = (props: HeroConsolidatedProps) => {
  const { variant } = props;

  switch (variant) {
    case HeroVariants.Blog:
      return <HeroBlogVariant {...props} />;
    case HeroVariants.BaseWithBlog:
      return <HeroBaseWithBlogVariant {...props} />;
    case HeroVariants.FullBleed:
      return <HeroFullBleedVariant {...props} />;
    case HeroVariants.Pillar:
      return <HeroPillarVariant {...props} />;
    case HeroVariants.Base:
    default:
      return <HeroBaseVariant {...props} />;
  }
};

export default HeroConsolidated;
